<template>
  <div>
    <div :style="styleObject" class="navbar">
      <span style="margin-left: 5px; font-size: 20px; cursor: pointer">
        <i
          v-if="!menuCollapse"
          class="el-icon-s-fold"
          title="收起"
          @click="closeMenu"
        />
        <i
          v-if="menuCollapse"
          class="el-icon-s-unfold"
          title="展开"
          @click="openMenu"
        />
      </span>
      <span style="margin-right: 15px">
        <!-- <span style="font-size:14px; margin-right:5px">
          {{ userInfo.org.fName }}
        </span> -->
        <el-dropdown @visible-change="visibleChange">
          <span style="cursor: pointer; font-size: 16px">
            {{ userInfo.name }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in switchOrgs"
              :key="item.fOrganizationID"
              @click.native="chgOrg(item)"
            >{{ item.fName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <span style="margin: 0px 5px; color: #c0c0c0">|</span>

        <el-dropdown>
          <span style="cursor: pointer; font-size: 16px">
            <!-- <i class="el-icon-user-solid"></i>  -->
            {{ userInfo.companyName }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="chgPW">修改密码</el-dropdown-item>
            <el-dropdown-item
              v-if="canRead"
              @click.native="lookBalance"
            >余额查看</el-dropdown-item>
            <el-dropdown-item
              @click.native="areaManager"
            >区域负责人</el-dropdown-item>
            <el-dropdown-item @click.native="askQuit">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </div>
  </div>
</template>

<script>
import ChangePassword from '@components/ChangePassword'
import PersonList from '@components/PersonList'
import BalanceList from '@components/BalanceList'

export default {
  components: {
    ChangePassword,
    PersonList,
    BalanceList
  },
  props: {
    menuCollapse: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      switchOrgs: [],
      canRead: false,
      styleObject: {
        background: '#fff'
      }
    }
  },
  computed: {
    userInfo: function() {
      return this.$store.state.userInfo
    }
  },
  mounted: function() {
    // this.refreshOrg();
    this.getUsertype()
    const companyName = this.$store.state.userInfo.companyName
    if (companyName == '杉山大唐') { this.styleObject.background = '#cadee8' } else if (companyName == '网约家康') {
      this.styleObject.background = '#e2b4c6'
    }
  },
  methods: {
    askQuit: function() {
      this.$confirm('是否退出登陆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$httpPost('Quit').then((res) => {
            this.$router.replace({ name: 'Login' })
          })
        })
        .catch(() => {
          // console.log('用户取消');
        })
    },
    chgPW: function() {
      const h = this.$createElement
      this.$formDlg({
        title: '修改密码',
        width: '30%',
        formTpl: <ChangePassword></ChangePassword>,
        formSubmit: (formData) => this.changePW(formData)
      })
    },
    chgOrg: function(org) {
      this.$confirm('切换组织将首先关闭所有标签页.是否继续?', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.$emit('SwitchOrg')
          this.$store.commit('changeUserOrg', org)
        })
        .catch(() => {
          // 取消操作
        })
    },
    visibleChange: function(visible) {
      if (visible) {
        // this.refreshOrg();
      }
    },
    refreshOrg: function() {
      this.$httpPost('SwitchOrganization', {}).then((res) => {
        this.switchOrgs = res.isSuccess ? res.datalist : []
      })
    },
    changePW: function(data) {
      return this.$httpPost('ChangePassword', data).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    closeMenu: function() {
      // console.log('closeMenu');
      this.$emit('update:menuCollapse', true)
    },
    openMenu: function() {
      // console.log('openMenu');
      this.$emit('update:menuCollapse', false)
    },
    lookBalance: function() {
      const h = this.$createElement
      this.$formDlg({
        title: '账户余额',
        formTpl: <BalanceList></BalanceList>,
        formSubmit: (formData) => this.changePW(formData),
        readonly: true
      })
    },
    areaManager: function() {
      const h = this.$createElement
      this.$formDlg({
        title: '区域负责人',
        width: '50%',
        formTpl: <PersonList></PersonList>,
        readonly: true
      })
    },
    getUsertype() {
      const jinxiaoshang = this.$store.state.userInfo.userType
      if (jinxiaoshang == '经销商') {
        this.canRead = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid gainsboro;
}
</style>
